<template>
  <div class="animated fadeIn">
    <!-- Modal Review -->
    <b-modal
      ref="reviewModal"
      lazy
      ok-only
      :title="modalTitle"
      size="lg"
    >
      <b-input-group
        v-show="$store.getters.isSuper && !hideTerm"
        name="partSet"
        prepend="연도"
        label-for="part"
        class="mb-2"
      >
        <b-form-select
          v-model="term"
          :options="termOptions"
          :state="term !== ''"
          @change="setTermForNewReview"
        />
      </b-input-group>
      <apply-review
        :apply-id="modalApplyId"
        :email="email"
        :review-id="modalReviewId"
        :read-only="!$store.getters.isRealSuper"
        @reviewUpdated="reviewUpdated()"
      />
    </b-modal>
    <b-row
      align-h="center"
      class="text-left"
    >
      <b-col md="12">
        <h4>
          {{ noReview ? '과거 수여 기록' : '과거 리뷰 기록' }}
          <b-button
            v-show="$store.getters.isRealSuper"
            variant="primary"
            size="sm"
            @click="getPastReview()"
          >
            등록
          </b-button>
        </h4>
      </b-col>
    </b-row>
    <b-row no-gutters="">
      <b-col
        v-for="(record, idx) in pastRecords"
        :key="idx"
        md="2"
      >
        <table>
          <th>{{ record.applyId.substring(0, 8) }}</th>
          <tr>{{ record.title }}</tr>
          <tr>{{ record.amount }}</tr>
          <tr>
            <b-button
              v-if="!noReview"
              variant="link"
              @click="getPastReview(record)"
            >
              리뷰보기
            </b-button>
          </tr>
        </table>
      </b-col>
      <b-col
        v-if="pastRecords.length === 0"
        md="12"
        class="text-left"
      >
        ------------------- 없음 -------------------
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <hr>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import api from '../../api'
import ApplyReview from '../admin/ApplyReview'

export default {
  name: 'RemnantPastReview',
  components: { ApplyReview },
  props: {
    email: {
      type: String,
      required: true
    },
    noReview: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      pastRecords: [],
      modalTitle: '',
      modalApplyId: '',
      modalReviewId: '',
      term: '',
      hideTerm: false
    }
  },
  computed: {
    termOptions () {
      let currentTerm = api.currentTerm()
      let termList = ['', currentTerm]
      if (currentTerm.split('-')[1] === '2nd') {
        termList.push(currentTerm.split('-')[0] + '-' + '1st')
      }
      let year = Number(currentTerm.split('-')[0])
      termList.push(String(year - 1) + '-2nd')
      termList.push(String(year - 1) + '-1st')
      return termList
    }
  },
  mounted () {
    if (this.email !== '') {
      this.getDetailInfo(1)
    }
  },
  methods: {
    setTermForNewReview (val) {
      this.modalTitle = '업데이트 - ' + val
      this.modalApplyId = val + '-apply-' + this.email
      this.modalReviewId = val + '-review-' + this.email
    },
    getPastReview (record) {
      if (record) {
        this.modalTitle = record.applyId.substring(0, 8)
        this.term = this.modalTitle
        this.modalApplyId = record.applyId
        this.modalReviewId = record.reviewId
        this.hideTerm = true
      } else {
        this.modalTitle = '새로 등록'
        this.modalApplyId = ''
        this.term = ''
        this.hideTerm = false
      }
      this.$refs.reviewModal.show()
    },
    parseDetailInfo (data) {
      this.pastRecords = []
      data.docs.forEach(doc => {
        if (doc.applyId.substring(0, 8) !== api.currentTerm()) {
          this.pastRecords.push(doc)
        }
      })
    },
    getDetailInfo (info) {
      api.request('get', '/admin/review/past?' + 'email=' + this.email + '&cnt=6')
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          this.parseDetailInfo(data)
        })
    },
    reviewUpdated () {
      if (this.email !== '') {
        this.getDetailInfo(1)
      }
    }
  }
}
</script>

<style>
</style>
